import http, { handleApiResponse } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import SpecialDimension from "../models/SpecialDimension";

export interface SaveSpecialDimensionRelationsRequest {
  code: string;
  invHead: number;
  invItem: number;
  items: SpecialDimension[];
}

export default class SpecialDimensionApi {
  /** Az élő speciális dimenziók + az adott bizonylat-kontextusban már rögzített megjegyzések. */
  static getRelations(
    code: string,
    invHead: number,
    invItem: number
  ): Promise<SpecialDimension[]> {
    return http
      .get<ApiResponse<SpecialDimension[]>>("special-dimension/relations", {
        params: { code, invHead, invItem },
      })
      .then(handleApiResponse);
  }

  /** A bizonylat-kontextushoz tartozó speciális dimenzió megjegyzések mentése (upsert). */
  static saveRelations(
    request: SaveSpecialDimensionRelationsRequest
  ): Promise<string> {
    return http
      .post<ApiResponse<string>>("special-dimension/relations/save", request)
      .then(handleApiResponse);
  }
}
